module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-control is-clearfix"
  }, [_c('div', {
    ref: "slider"
  }), _vm._v(" "), _c('div', {
    staticClass: "slider-output"
  }, [_c('div', {
    ref: "event_start",
    staticClass: "is-pulled-left",
    attrs: {
      "id": "event-start"
    }
  }), _vm._v(" "), _c('div', {
    ref: "event_end",
    staticClass: "is-pulled-right",
    attrs: {
      "id": "event-end"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356ef480"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/SliderControl.vue
// module id = 522
// module chunks = 0